import React, { useEffect, useState } from 'react';
import './Content.css';
import { trackProductClick } from '../services/posthogSetup';

function Content() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch('/data/Content.json') // Fetch the Content data
      .then(response => response.json())
      .then(data => setData(data.Content)) // Access the "Content" key directly
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  if (!data) return <div>Loading...</div>;

  return (
    <div className="category">
      <h2>Content</h2>
      <div className="subcategories">
        {Object.keys(data).map(subcategory => (
          <div className="subcategory" key={subcategory}>
            <h3>{subcategory}</h3>
            <div className="items">
              {Array.isArray(data[subcategory]) ? (
                data[subcategory].map(item => (
                  <div className="item" key={item.name}>
                    <a href={item.url} target="_blank" rel="noopener noreferrer" onClick={() => trackProductClick('Content', subcategory, item.name, item.url)}>
                      <img src={item.logo} alt={`${item.name} logo`} />
                      <span className="item-name">{item.name}</span>
                    </a>
                  </div>
                ))
              ) : (
                <p>Invalid data format for {subcategory}</p> // Fallback for non-array data
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Content;
